{
    "NAME": "Databasetaal",
    "Database_Section_MaintenanceInterval_Title": "Onderhoudsinterval database",
    "Database_Section_MaintenanceInterval_Description": "Configureer een dagelijkse periode waarin de applicatie de databaseactiviteit opschort. De begin- en eindtijd worden geïnterpreteerd als UTC.",
    "Database_Field_MaintenanceInterval_Enabled": "Databaseactiviteit dagelijks opschorten",
    "Database_Field_MaintenanceInterval_TimeStart": "Begintijd (UTC)",
    "Database_Field_MaintenanceInterval_TimeEnd": "Eindtijd (UTC)",
    "Database_Field_MaintenanceInterval_DaysOfWeek": "Dagen van de week",
    "Database_Day_Monday": "Maandag",
    "Database_Day_Tuesday": "Dinsdag",
    "Database_Day_Wednesday": "Woensdag",
    "Database_Day_Thursday": "Donderdag",
    "Database_Day_Friday": "Vrijdag",
    "Database_Day_Saturday": "Zaterdag",
    "Database_Day_Sunday": "Zondag",
    "Database_Action_Apply": "Toepassen",
    "Database_Action_Cancel": "Annuleren",
    "Database_Action_Refresh": "Vernieuwen",
    "Database_Save_Success": "Database-instellingen opgeslagen.",
    "Database_Save_Error": "Database-instellingen kunnen niet worden opgeslagen.",
    "Database_Load_Error": "Database-instellingen kunnen niet worden geladen.",
    "Database_Warning_ReadOnly": "U kunt deze instellingen bekijken, maar u hebt geen toestemming om ze te wijzigen. Alleen systeembeheerders met root-toegang kunnen database-instellingen bewerken.",
    "Database_Warning_Unavailable": "De database-instellingen zijn momenteel niet beschikbaar. De database was mogelijk niet toegankelijk toen de applicatie werd gestart."
}